/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Facts_Languages_ValueInputs */

const en_vc_facts_languages_value = /** @type {(inputs: Vc_Facts_Languages_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`21 languages, incl. Chinese`)
};

const zh_vc_facts_languages_value = /** @type {(inputs: Vc_Facts_Languages_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`21 种，含简繁中文`)
};

/**
* | output |
* | --- |
* | "21 languages, incl. Chinese" |
*
* @param {Vc_Facts_Languages_ValueInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_facts_languages_value = /** @type {((inputs?: Vc_Facts_Languages_ValueInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Facts_Languages_ValueInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_facts_languages_value(inputs)
	return zh_vc_facts_languages_value(inputs)
});
export { vc_facts_languages_value as "vc.facts.languages.value" }